import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import { DashboardLayout, BUSINESS_NAV, ADMIN_NAV } from "@/components/DashboardLayout";
import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import { PaymentSuccess, PaymentCancel } from "@/pages/PaymentResult";
import Overview from "@/pages/app/Overview";
import Candidates from "@/pages/app/Candidates";
import CandidateDetail from "@/pages/app/CandidateDetail";
import Shortlist from "@/pages/app/Shortlist";
import Requests from "@/pages/app/Requests";
import Messages from "@/pages/app/Messages";
import Resources from "@/pages/app/Resources";
import Membership from "@/pages/app/Membership";
import AdminOverview from "@/pages/admin/AdminOverview";
import AdminCandidates from "@/pages/admin/AdminCandidates";
import AdminRequests from "@/pages/admin/AdminRequests";
import AdminMessages from "@/pages/admin/AdminMessages";
import AdminResources from "@/pages/admin/AdminResources";
import AdminMembers from "@/pages/admin/AdminMembers";
import AdminApplications from "@/pages/admin/AdminApplications";
import AdminDocuments from "@/pages/admin/AdminDocuments";
import Apply from "@/pages/Apply";
import Compare from "@/pages/app/Compare";
import BusinessProfile from "@/pages/app/BusinessProfile";
import Documents from "@/pages/app/Documents";
import CandidateHome from "@/pages/candidate/CandidateHome";
import CandidateOffers from "@/pages/candidate/CandidateOffers";
import CandidateProfile from "@/pages/candidate/CandidateProfile";
import BusinessView from "@/pages/candidate/BusinessView";
import Jobs from "@/pages/app/Jobs";
import JobDetail from "@/pages/JobDetail";
import AdminJobs from "@/pages/admin/AdminJobs";
import CandidateJobs from "@/pages/candidate/CandidateJobs";
import CandidateAvailability from "@/pages/candidate/CandidateAvailability";
import { CANDIDATE_NAV } from "@/components/DashboardLayout";
import Account from "@/pages/Account";
import Privacy from "@/pages/Privacy";
import { NativeBridge, NativeHome } from "@/components/NativeBridge";
import { isNative } from "@/lib/native";

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <NativeBridge />
          <Routes>
            <Route path="/" element={isNative ? <NativeHome /> : <Landing />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/apply" element={<Apply />} />
            <Route path="/payment/success" element={<PaymentSuccess />} />
            <Route path="/payment/cancel" element={<PaymentCancel />} />
            <Route path="/app" element={<ProtectedRoute role="business"><DashboardLayout items={BUSINESS_NAV} /></ProtectedRoute>}>
              <Route index element={<Overview />} />
              <Route path="candidates" element={<Candidates />} />
              <Route path="candidates/:id" element={<CandidateDetail />} />
              <Route path="shortlist" element={<Shortlist />} />
              <Route path="requests" element={<Requests />} />
              <Route path="messages" element={<Messages />} />
              <Route path="resources" element={<Resources />} />
              <Route path="membership" element={<Membership />} />
              <Route path="compare" element={<Compare />} />
              <Route path="business-profile" element={<BusinessProfile />} />
              <Route path="documents" element={<Documents />} />
              <Route path="jobs" element={<Jobs />} />
              <Route path="jobs/:id" element={<JobDetail />} />
              <Route path="account" element={<Account />} />
            </Route>
            <Route path="/candidate" element={<ProtectedRoute role="candidate"><DashboardLayout items={CANDIDATE_NAV} candidate /></ProtectedRoute>}>
              <Route index element={<CandidateHome />} />
              <Route path="jobs" element={<CandidateJobs />} />
              <Route path="availability" element={<CandidateAvailability />} />
              <Route path="profile" element={<CandidateProfile />} />
              <Route path="offers" element={<CandidateOffers />} />
              <Route path="documents" element={<Documents />} />
              <Route path="messages" element={<Messages />} />
              <Route path="businesses/:id" element={<BusinessView />} />
              <Route path="account" element={<Account />} />
            </Route>
            <Route path="/admin" element={<ProtectedRoute role="admin"><DashboardLayout items={ADMIN_NAV} admin /></ProtectedRoute>}>
              <Route index element={<AdminOverview />} />
              <Route path="candidates" element={<AdminCandidates />} />
              <Route path="candidates/:id" element={<CandidateDetail />} />
              <Route path="requests" element={<AdminRequests />} />
              <Route path="messages" element={<AdminMessages />} />
              <Route path="resources" element={<AdminResources />} />
              <Route path="members" element={<AdminMembers />} />
              <Route path="applications" element={<AdminApplications />} />
              <Route path="businesses/:id" element={<BusinessView />} />
              <Route path="jobs" element={<AdminJobs />} />
              <Route path="jobs/:id" element={<JobDetail />} />
              <Route path="account" element={<Account />} />
            </Route>
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
        <Toaster position={isNative ? "top-center" : "top-right"} richColors />
      </AuthProvider>
    </div>
  );
}

export default App;
